/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {PackageCategory} from "types/enums/PackageCategory";
import {useHistory} from "react-router-dom";
import {useDispatch} from "useDispatch";
import {useTypedSelector} from "helpers/reducers";
import BookingAction from "store/booking/BookingAction";
import {appendQueryParams} from "utils/utility";
import Loader from "components/Loader";
import clsx from "clsx";
import PackageCategoryCard from "pages/Front/Booking/components/PackageCategoryCard";
import {withRouter} from "react-router";
import {ThunkAction} from "redux-thunk";
import {useTranslation} from "react-i18next";
import {usePackageCategory} from "utils/hooks/usePackageCategory";

const BookingFerienSubcategory = () => {
    const {t} = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    const hall = useTypedSelector(state => state.hallState.hall);
    const bookingFilter = useTypedSelector(state => state.bookingState.bookingProcess.filter);

    const {ferienSubcategories} = usePackageCategory();
    const packageCategoryCardHandle = (categorySlug: PackageCategory) => {
        dispatch(
            BookingAction.setFilter({
                ...bookingFilter,
                category: categorySlug,
            })
        );

        // initCart and remove booking process
        dispatch<ThunkAction<any, any, any, any>>(BookingAction.initCart()).then(r => {
            // dispatch(BookingAction.clearBookingProcess());
            if (categorySlug == PackageCategory.ThreeTwo) {
                return history.push("/booking/package/21?" + appendQueryParams(bookingFilter));
            }
            return history.push("/booking/options" + "?" + appendQueryParams(bookingFilter));
        });
    };

    const openPackageCategoryDetail = (categorySlug: PackageCategory) => {
        return history.push("/booking/ferien/detail/" + categorySlug + "?" + appendQueryParams(bookingFilter));
    };

    if (!hall) {
        return (
            <div>
                <Loader />
            </div>
        );
    }

    return (
        <div className={clsx("w-full grid grid-cols-6 gap-8 snap-y")}>
            {ferienSubcategories
                .filter(category => category.enable)
                .map((category, index) => {
                    return (
                        <PackageCategoryCard
                            key={index}
                            categoryEntity={category}
                            className={"col-span-6"}
                            index={index}
                            showMoreDetail={false}
                            onClick={() => packageCategoryCardHandle(category.id)}
                            onDetailClick={() => openPackageCategoryDetail(category.id)}
                        />
                    );
                })}
        </div>
    );
};

export default withRouter(BookingFerienSubcategory);
